<template>
    <div>
        <Toolbar>
            <BackButton :to="__('general.subscription')" :href="$route('subscriptions')"/>
        </Toolbar>

        <Card>
            <template v-slot:title>Get more addons</template>

<!--            <ul>-->
<!--                <li v-for="addon in addons">{{ addon.lang.name }}</li>-->
<!--            </ul>-->

            <p>This feature is currently not available, please <a :href="$route('contact')">contact our support</a> to request more addons.</p>

<!--            <template v-slot:footer>-->
<!--                <button class="btn btn-primary disabled" disabled>-->
<!--                    <i class="fas fa-plus-square" />-->
<!--                    Zahlungspflichtig bestellen-->
<!--                </button>-->
<!--            </template>-->
        </Card>
    </div>
</template>

<script>
import Toolbar from "@components/Toolbar.vue";
import BackButton from "@components/BackButton.vue";
import Card from "@components/Cards/Card.vue";

export default {
    components: {Card, BackButton, Toolbar},

    props: {
        storesCount: Number,
        addons: Array
    }
}
</script>
